import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mt-4" }

import { ref, onMounted } from "vue";
import { translation } from "../../../lang/Translation";
import PageNation from "../../../../framework/components/table/PageNation.vue";
import FileCardSectionWithoutDelete from "./FileCardSectionWithoutDelete.vue";
import axios from "axios";
import FileFilterByTypeSection from "./FileFilterByTypeSection.vue";

interface PresetFile {
  filePath: string;
  thumbnailPath: string;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PresetFilesSection',
  setup(__props) {

const t = translation;
const list = ref<PresetFile[]>([]);
const dispList = ref([] as PresetFile[]);
const dispSize = ref(12);
const currentPage = ref(1);

// ページネイションの移動
const pageChanged = (rowInPage: PresetFile[], currentPageNew: number) => {
  currentPage.value = currentPageNew + 1;
  dispList.value = rowInPage;
};

const filterChanged = (filteredRows: PresetFile[], type: string) => {
  dispList.value = filteredRows;
};

/**
 * リストの取得
 */
const getList = async () => {
  //  const url = new URL(location.href)
  //  url.pathname = `/public/preset/preset.json`
  //  const response = await axios.get<PresetFile[]>(url.href);
  const response = await axios.get<PresetFile[]>(`../../public/preset/preset.json`);

  list.value = response.data;
  dispList.value = response.data;
};

onMounted(() => {
  getList().then();
});

return (_ctx: any,_cache: any) => {
  const _component_NoFilesInSection = _resolveComponent("NoFilesInSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", _hoisted_1, _toDisplayString(_unref(t).to("おすすめアセット", "recommend_asset")), 1),
    _createVNode(FileFilterByTypeSection, {
      lows: list.value,
      "on-filter-changed": filterChanged
    }, null, 8, ["lows"]),
    (dispList.value.length < 1)
      ? (_openBlock(), _createBlock(_component_NoFilesInSection, { key: 0 }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dispList.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.filePath,
        class: "col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12"
      }, [
        _createVNode(FileCardSectionWithoutDelete, {
          "file-path": item.filePath,
          "thumbnail-path": item.thumbnailPath,
          index: index,
          class: _normalizeClass({ added: true }),
          name: item.name
        }, null, 8, ["file-path", "thumbnail-path", "index", "name"])
      ]))
    }), 128))
  ], 64))
}
}

})